"use strict";
/**
* Copyright: Microsoft 2016
* Maps locale (from unsupported to supported) following same schema as S4L
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLocale = function (locale) {
    locale = locale.toLowerCase();
    switch (locale) {
        //locales where "British" is preferred fallback
        case 'en-gb':
        case 'en-ca':
        case 'en-au':
        case 'en-in':
        case 'en-nz':
        case 'en-hk':
        case 'en-ie':
        case 'en-pk':
        case 'en-sg':
            return 'en-GB';
        //special handling for Spanish(US) [within top 10 locales for T1 Android]
        case 'es-us':
            return 'es-US';
        //for all Latin America, use Spanish(Mexico)
        case 'es-mx':
        case 'es-co':
        case 'es-ar':
        case 'es-cl':
        case 'es-pe':
        case 'es-ec':
        case 'es-ve':
        case 'es-cr':
        case 'es-do':
        case 'es-uy':
        case 'es-pa':
        case 'es-gt':
        case 'es-bo':
        case 'es-ev':
        case 'es-hn':
        case 'es-ni':
        case 'es-pu':
        case 'es-br':
        case 'es-pr':
        case 'es-419':
            return 'es-MX';
        //only in Portugal, load pt-PT. Everywhere else, the default for pt-* is pt-BR
        //we may want to change file-names (at the moment we have _pt.json and _pt-BR.json), but i would leave it as it is
        case 'pt-pt':
            return 'pt';
        //For Hong Kong SAR only, load Chinese Traditional. Otherwise, the default for zh-* is Chinese Simplified
        case 'zh-tw':
        case 'zh-hk':
            return 'zh-TW';
        //now handling only the <ll> part of <ll-CC> [note: special handling for zh-Hans\Hant in iOS]
        default:
            if (locale === 'zh-tw' || locale.substr(0, 7) === 'zh-hant') {
                return 'zh-TW';
            }
            else {
                var newLocale = locale.substr(0, 2);
                switch (newLocale) {
                    case 'ar':
                        return 'ar';
                    case 'de':
                        return 'de';
                    // Galician, Basque --> Spanish
                    case 'es':
                    case 'gl':
                    case 'eu':
                        return 'es';
                    case 'et':
                        return 'et';
                    case 'fr':
                        return 'fr';
                    //iw is an obsolete language-code for Hebrew, but still widely used on Android platforms. It just falls-back to he.
                    case 'he':
                    case 'iw':
                        return 'he';
                    case 'hi':
                        return 'hi';
                    case 'it':
                        return 'it';
                    case 'ja':
                        return 'ja';
                    case 'nl':
                        return 'nl';
                    //note: default for Portuguese is Portuguese (Brazil)
                    case 'pt':
                        return 'pt-BR';
                    case 'tr':
                        return 'tr';
                    case 'ru':
                        return 'ru';
                    case 'zh':
                        return 'zh-CN';
                    //languages added after Preview2
                    case 'bg':
                        return 'bg';
                    case 'ca':
                        return 'ca';
                    case 'hr':
                        return 'hr';
                    case 'cs':
                        return 'cs';
                    case 'da':
                        return 'da';
                    case 'fi':
                        return 'fi';
                    case 'el':
                        return 'el';
                    case 'hu':
                        return 'hu';
                    case 'id':
                        return 'id';
                    case 'ko':
                        return 'ko';
                    case 'lv':
                        return 'lv';
                    case 'lt':
                        return 'lt';
                    case 'ms':
                        return 'ms';
                    case 'nb':
                        return 'nb';
                    //old 'no' for Norwegian from Stratus should be mapped to 'nb'
                    case 'no':
                        return 'nb';
                    case 'pl':
                        return 'pl';
                    case 'ro':
                        return 'ro';
                    //all Serbian fall-back to Latin script
                    case 'sr':
                        return 'sr-Latn';
                    case 'sk':
                        return 'sk';
                    case 'sl':
                        return 'sl';
                    case 'sv':
                        return 'sv';
                    case 'th':
                        return 'th';
                    case 'uk':
                        return 'uk';
                    case 'vi':
                        return 'vi';
                    //default of default --> en
                    default:
                        return 'en';
                }
            }
    }
};
